import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import * as v1 from '@app/v1_integration';
import { Store } from '@ngrx/store';
import { BaseService } from '@services/base.services';
import '@shared/utils/rxjs.operators';
import { ForgotPasswordResult } from '@staff-app/models/forgotPasswordResult';
import * as fromAuthActions from '@store/actions/auth.actions';
import * as fromRoot from '@store/reducers';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { from, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable()
export class AuthService extends BaseService {
  constructor(
    @Inject(v1.v1_pulseContextServiceName)
    private _v1PulseContext: v1.IPulseContextService,
    @Inject(v1.v1_commonServiceName) private _v1Common: v1.ICommon,
    @Inject(v1.v1_breezeServiceName)
    private _breezeService: Pulse.Services.IBreezeService,
    private _store: Store<fromRoot.State>,
    private _htc: HttpClient,
    @Inject(SESSION_STORAGE) private _storage: StorageService
  ) {
    super();
    // Hookup event from v1 that tracks login success.
    this._v1Common.$rootScope.$on(Events.LoginSuccess, event => {
      this.loginSuccessFromV1();
    });
  }

  login(auth: Authenticate): Observable<AuthData> {
    // Using V1's existing login logic.  Will migrate this in the future.
    const login$ = from(this._v1PulseContext.login(
      auth.username,
      auth.password
    ) as any).pipe(
      map((response: any) => {
        if (!(response && response.access_token)) {
          new Error('Login Failed.');
        }
        return <AuthData>this._v1PulseContext.authData;
      }),
      catchError(err => {
        return throwError(err);
      })
    );

    return login$;

    // const body = `grant_type=password&username=${encodeURIComponent(
    //   auth.username
    // )}&password=${encodeURIComponent(auth.password)}`;

    // // JSON.stringify(body)
    // return this._htc
    //   .post(`${this.PULSE_API_BASE_URL}/token`, body, {
    //     headers: new HttpHeaders().set(
    //       'Content-Type',
    //       'application/x-www-form-urlencoded'
    //     )
    //   })
    //   .map(response => {
    //     this._storage.set('zigzag2_authorizationData', {
    //       token: (<AuthToken>response).access_token,
    //       userName: auth.username
    //     });
    //     return <AuthToken>response;
    //   })
    //   .catch(response => {
    //     return throwError(response.error);
    //     // TODO: this need to be refactored
    //   });
  }

  logout(instruct: LogoutInstruction) {
    this._v1PulseContext.logout(
      instruct.clearAllState,
      instruct.resetBrowseIdentifier
    );
  }

  forgotPWRetrieval(
    emailAddress: string,
    captchaResponse: string
  ): Observable<ForgotPasswordResult> {


    return this._htc
      .post(
        `${environment.webApi_NonBreeze}/User_ForgotPWRetrieval`,
        {
          emailOrUsername: emailAddress,
          captchaResponse: captchaResponse,
          isFromJobApp: true
        },
        {
          headers: new HttpHeaders().set(
            'Content-Type',
            'application/json;charset=UTF-8'
          )
        }
      )
      .map(response => {
        return (<any>response) as ForgotPasswordResult;
      });


    // const query = breeze.EntityQuery.from('User_ForgotPWRetrieval')
    //   .withParameters({
    //     emailOrUsername: emailAddress,
    //     captchaResponse: captchaResponse,
    //     isFromJobApp: true
    //   })
    //   .noTracking(true)
    //   .take(1); // There should only be one.

    // const promise = this._breezeService
    //   .getEntityManager()
    //   .executeQuery(query)
    //   .then(data => {
    //     return <ForgotPasswordResult>(<any>data.results[0]);
    //   });


  }

  validateResetPasswordCode(
    userId: number,
    emailAddress: string,
    resetCode: string
  ): Observable<ForgotPasswordResult> {

    return this._htc
    .post(
      `${environment.webApi_NonBreeze}/User_ForgotPWValidateResetCode`,
      {
        userId: userId,
        primaryEmail: emailAddress,
        resetCode: resetCode
      },
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/json;charset=UTF-8'
        )
      }
    )
    .map(response => {
      return (<any>response) as ForgotPasswordResult;
    });

    // const query = breeze.EntityQuery.from('User_ForgotPWValidateResetCode')
    //   .withParameters({
    //     userId: userId,
    //     primaryEmail: emailAddress,
    //     resetCode: resetCode
    //   })
    //   .noTracking(true)
    //   .take(1); // There should only be one.

    // const promise = this._breezeService
    //   .getEntityManager()
    //   .executeQuery(query)
    //   .then(data => {
    //     return <ForgotPasswordResult>(<any>data.results[0]);
    //   });

    // return from(promise);
  }

  resetPassword(
    userId: number,
    resetCode: string,
    newPassword: string
  ): Observable<ForgotPasswordResult> {
    return this._htc
    .post(
      `${environment.webApi_NonBreeze}/User_ForgotPWChangePassword`,
      {
        'userId': userId,
        'resetCode': resetCode,
        'newPassword': newPassword,
        'newPasswordCofirm': newPassword
      },
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/json;charset=UTF-8'
        )
      }
    )
    .map(response => {
      return (<any>response) as ForgotPasswordResult;
    });



    // const query = breeze.EntityQuery.from('User_ForgotPWChangePassword')
    //   .withParameters({
    //     userId: userId,
    //     resetCode: resetCode,
    //     newPassword: newPassword
    //   })
    //   .noTracking(true)
    //   .take(1); // There should only be one.

    // const promise = this._breezeService
    //   .getEntityManager()
    //   .executeQuery(query)
    //   .then(data => {
    //     return <ForgotPasswordResult>(<any>data.results[0]);
    //   });

    // return from(promise);
  }

  changePassword(
    userId: number,
    newPassword: string
  ): Observable<any> {
    return this._htc
      .post(
        `${environment.webApi_NonBreeze}/UserAcct_SetNewPassword`,
        {
          userId: userId,
          newPassword: newPassword
        },
        {
          headers: new HttpHeaders().set(
            'Content-Type',
            'application/json;charset=UTF-8'
          )
        }
      )
      .map(response => {
        return response;
      });
  }


  getPrivacyPolicyContent(): Observable<string> {
    const query = breeze.EntityQuery.from('User_GetPrivacyPolicyContent')
      .noTracking(true)
      .take(1); // There should only be one.

    const promise = this._breezeService
      .getEntityManager()
      .executeQuery(query)
      .then(data => {
        return <string>(<any>data.results[0]);
      });

    return from(promise);
  }

  /**
   *
   * @param token
   */
  private loginSuccessFromV1() {
    // This is triggered from V1 login event, which means there should be a loggedInUser available.
    // First check to see if we already have the token and user.
    const authData = this._v1PulseContext.authData;
    if (authData && authData.token) {
      // This method could be called multiple times from v1 and v2.
      // check to see if token is already obtained.

      // short circuit from v1, v2 needs it's own login
      this._store.dispatch(new fromAuthActions.LoginSuccess(authData));

      //   const subscription = this._store
      //     .select(fromRoot.getAuthData)
      //     .subscribe(authDataInStore => {
      //       if (subscription) {
      //         subscription.unsubscribe();
      //       } // Unsubscribe to prevent memory leak.
      //       if (
      //         authDataInStore &&
      //         authDataInStore.userId === authData.userId &&
      //         authDataInStore.token === authData.token
      //       ) {
      //         // Already logged in.
      //         return;
      //       }
      //       if (this._v1PulseContext) {
      //         this._store.dispatch(new fromAuthActions.LoginSuccess(authData));
      //       }
      //     });
      // } else {
      //   throw new Error('Login error.');
      // }
    }
  }
}

export interface Authenticate {
  username: string;
  password: string;
}

export interface AuthData extends v1.IPulseContextService_IAuthData { }

export interface LogoutInstruction {
  clearAllState?: boolean;
  resetBrowseIdentifier?: boolean;
  noRedirectAfterLogout?: boolean;
}
